"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModel = void 0;
var Processor = __importStar(require("@microchip/scf-common/lib/Processor"));
var AutoModuleAppModel_1 = require("../autoModule/AutoModuleAppModel");
var AutoModuleHelpers_1 = require("../autoModule/AutoModuleHelpers");
var getConfigData_1 = require("../autoModule/getConfigData");
var exports_1 = require("../interfaces/exports");
var imports_1 = require("../interfaces/imports");
var PCPHelper_1 = require("../pins/PCPHelper");
var tables_1 = require("../tables/tables");
var getModel = function (prototype, getDerivedData) {
    return new MyAppModel(prototype, getDerivedData);
};
exports.getModel = getModel;
var MyAppModel = /** @class */ (function () {
    function MyAppModel(prototype, getDerivedData) {
        var _this = this;
        this.getState = function () { return _this.prototype.state; };
        this.getPayload = function () { return _this.prototype.payload; };
        this.getImports = function () { return _this.prototype.imports; };
        this.getExports = function () { return _this.prototype.exports; };
        this.getName = function () {
            return _this.getAutoModuleAppModel().getModuleName();
        };
        this.getCategory = function () {
            return _this.getAutoModuleAppModel().getModuleCategory();
        };
        this.getActiveName = function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = _this.getDerivedFunctions()).getActiveName) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : _this.getName();
        };
        this.getGlobalNames = function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = _this.getDerivedFunctions()).getGlobalNames) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : [];
        };
        this.getAutoModuleAppModel = function () {
            if (_this.autoModuleAppModel)
                return _this.autoModuleAppModel;
            _this.autoModuleAppModel = (0, AutoModuleAppModel_1.createAutoModuleAppModel)(_this);
            return _this.autoModuleAppModel;
        };
        this.getPrototypeModule = function () {
            return _this.prototype;
        };
        this.getRegisterValues = function (interfaceName) {
            if (_this.registerValues)
                return _this.registerValues;
            _this.registerValues = (0, AutoModuleHelpers_1.getRegisterValues)(_this, interfaceName);
            return _this.registerValues;
        };
        this.getInterrupts = function () {
            var _a, _b;
            if (_this.interrupts)
                return _this.interrupts;
            _this.interrupts = (_b = (_a = _this.getHardware()) === null || _a === void 0 ? void 0 : _a.getPeripheral()) === null || _b === void 0 ? void 0 : _b.interrupts;
            return _this.interrupts;
        };
        this.getProperties = function () {
            var _a, _b;
            if (_this.properties)
                return _this.properties;
            _this.properties = (_b = (_a = _this.getHardware()) === null || _a === void 0 ? void 0 : _a.getPeripheral()) === null || _b === void 0 ? void 0 : _b.properties;
            return _this.properties;
        };
        this.getRegisters = function () {
            var _a, _b;
            if (_this.registers)
                return _this.registers;
            _this.registers = (_b = (_a = _this.getHardware()) === null || _a === void 0 ? void 0 : _a.getPeripheral()) === null || _b === void 0 ? void 0 : _b.registers;
            return _this.registers;
        };
        this.getHardware = function (interfaceName) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            interfaceName = (0, AutoModuleHelpers_1.getFriendlyInterfaceId)(interfaceName);
            if (interfaceName) {
                var peripheral_1 = (_c = (_b = (_a = _this.getPrototypeModule()) === null || _a === void 0 ? void 0 : _a.imports) === null || _b === void 0 ? void 0 : _b[interfaceName]) === null || _c === void 0 ? void 0 : _c.payload;
                if (!peripheral_1)
                    return undefined;
                return {
                    getPeripheral: function () { return peripheral_1; },
                    getName: function () { return peripheral_1.name; },
                    instanceNumber: Number((_d = peripheral_1.instance) !== null && _d !== void 0 ? _d : peripheral_1.name.replace(peripheral_1.group, "")),
                };
            }
            if (!_this.defaultHardware) {
                var peripheralName = (0, AutoModuleHelpers_1.getFriendlyInterfaceId)((_g = (_f = (_e = (0, getConfigData_1.getConfigData)(_this)) === null || _e === void 0 ? void 0 : _e.peripherals) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.interfaceId.name);
                var peripheral_2 = (_k = (_j = (_h = _this.getPrototypeModule()) === null || _h === void 0 ? void 0 : _h.imports) === null || _j === void 0 ? void 0 : _j[peripheralName !== null && peripheralName !== void 0 ? peripheralName : ""]) === null || _k === void 0 ? void 0 : _k.payload;
                if (peripheral_2) {
                    _this.defaultHardware = {
                        getPeripheral: function () {
                            return peripheral_2;
                        },
                        getName: function () { return peripheral_2.name; },
                        instanceNumber: Number((_l = peripheral_2.instance) !== null && _l !== void 0 ? _l : peripheral_2.name.replace(peripheral_2.group, "")),
                    };
                }
            }
            return _this.defaultHardware;
        };
        this.getPeripheralDescription = function () {
            var _a;
            return (_a = _this.getHardware()) === null || _a === void 0 ? void 0 : _a.getPeripheral();
        };
        this.getDerivedData = function () {
            if (_this.derivedData)
                return _this.derivedData;
            _this.derivedData = _this.getDerivedDataFunction(_this);
            return _this.derivedData;
        };
        this.getDerivedFunctions = function () {
            return _this.getDerivedData().getMyFunctions();
        };
        this.getDerivedFunction = function (functionName) {
            var _a, _b;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return (_b = (_a = _this.getDerivedFunctions()) === null || _a === void 0 ? void 0 : _a[functionName]) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args, false));
        };
        this.getExportInterfaces = function () {
            if (_this.exportInterfaces)
                return _this.exportInterfaces;
            _this.exportInterfaces = (0, exports_1.createExportInterfaces)(_this.prototype.exports, _this);
            return _this.exportInterfaces;
        };
        this.getImportInterfaces = function () {
            if (_this.importInterfaces)
                return _this.importInterfaces;
            _this.importInterfaces = (0, imports_1.createImportInterfaces)(_this.prototype.imports, _this);
            return _this.importInterfaces;
        };
        this.isControlledByInterface = function (componentName) {
            var _a;
            return ((_a = _this.getExportInterfaces()) === null || _a === void 0 ? void 0 : _a.isControlledByInterface(componentName)) == true;
        };
        this.getAssignedImport = function (importName) {
            var _a;
            if (((_a = _this.prototype.imports) === null || _a === void 0 ? void 0 : _a[importName]) &&
                Processor.isAssigned(_this.prototype.imports[importName])) {
                return _this.prototype.imports[importName];
            }
            return undefined;
        };
        this.getImportValue = function (importName) {
            var _a;
            return (_a = _this.getAssignedImport(importName)) === null || _a === void 0 ? void 0 : _a.payload;
        };
        this.filterImportBySetting = function (populatedImports, importKey, optionFilter) {
            var _a;
            var filteredImports = __assign({}, populatedImports);
            if (populatedImports[importKey]) {
                filteredImports = __assign(__assign({}, filteredImports), (_a = {}, _a[importKey] = Processor.filterOptions(populatedImports[importKey], function (option) {
                    return optionFilter(option);
                }), _a));
            }
            return filteredImports;
        };
        this.isComponentValue = function (componentName) {
            var value = _this.getComponentValue(componentName);
            return value === true || value === "enabled";
        };
        this.getComponent = function (componentName) {
            return _this.getAutoModuleAppModel().getComponent(componentName);
        };
        this.getPCPHelper = function () {
            if (!_this.pcpHelper) {
                _this.pcpHelper = new PCPHelper_1.PCPHelper();
                _this.pcpHelper.setCallbacks({
                    getCompletePinData: function () { var _a, _b; return (_b = (_a = _this.getDerivedFunctions()).getPinsLogic) === null || _b === void 0 ? void 0 : _b.call(_a).getCompletePinData(_this); },
                    getRowData: function (rowData) { var _a, _b; return (_b = (_a = _this.getDerivedFunctions()).getPinsLogic) === null || _b === void 0 ? void 0 : _b.call(_a).getRowData(_this, rowData); },
                    getPinsData: function () { var _a, _b; return (_b = (_a = _this.getDerivedFunctions()).getPinsLogic) === null || _b === void 0 ? void 0 : _b.call(_a).getPinsData(); },
                });
            }
            return _this.pcpHelper;
        };
        this.getTableHelpers = tables_1.getTableHelpers;
        this.prototype = prototype;
        this.getDerivedDataFunction = getDerivedData;
    }
    MyAppModel.prototype.getComponentValue = function (componentName) {
        return this.getAutoModuleAppModel().getComponentValue(componentName);
    };
    return MyAppModel;
}());
//# sourceMappingURL=AppModel.js.map